import styled from "styled-components";
import { Modal, NewButton } from "@bca/ui-library";
import { Link } from "react-router-dom";
import theme from "../../styles/theme";

export const StyledModal = styled(Modal)`
  width: ${(props) => (props.isMobile ? "22.188rem" : "31.938rem")};
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalTitle = styled.div`
  margin-top: 1rem;
  font-weight: 700;
  font-size: 1.25rem;
  text-align: center;
`;

export const ModalSubtitle = styled.div`
  font-weight: 700;
  font-size: 0.938rem;
  margin-top: 2rem;
`;

export const StyledModalText = styled.div`
  font-size: 0.875rem;
  text-align: center;
`;

export const StyledModalTextColored = styled(Link)`
  color: ${theme.color.ctaActionLink};
  text-decoration: none;
  cursor: pointer;
  font-weight: 700;
`;

export const StyledUl = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  color: ${theme.color.gray};
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;

export const StyledModalTextBold = styled(StyledModalText)`
  font-weight: 700;
`;

export const StyledNewButton = styled(NewButton)`
  margin-top: 1.938rem;
  width: ${(props) => (props.isMobile ? "8.18rem" : "11.43rem")};
`;
